// extracted by mini-css-extract-plugin
module.exports = {"chromeframe":"Frame_chromeframe__36Cqh","top":"Frame_top__3_xTF","bottom":"Frame_bottom__2zBU1","left":"Frame_left__3CYK7","right":"Frame_right__1CK7E"};